<script setup>
import commonUtils from "@/utils/commonUtils";
import { useTemplateStore } from "@/stores/template";
import { ref, watch } from "vue";

const props = defineProps({
  promotionDeals: {},
});
const baseUrl = "/api/v3/content/collections/images";

const templateStore = useTemplateStore();

let equipmentType = ref(templateStore.responsive.equipmentType);

watch(
  () => templateStore.responsive.equipmentType,
  (newValue) => {
    equipmentType.value = newValue;
  }
);
</script>
<template>
  <section
    v-if="
      commonUtils.sortByParams(promotionDeals, 'sequenceNumber') &&
      commonUtils.sortByParams(promotionDeals, 'sequenceNumber').length > 0
    "
    id="go_beyond_area"
    class="section_padding_top"
  >
    <div class="container">
      <div class="row align-items-center">
        <div :class="{ 'col-12': equipmentType === 'iphone' }" class="col-3">
          <div class="heading_left_area">
            <h2>{{ $t("go-beyond-your-imagination") }}</h2>
            <h5>{{ $t("discover-your-ideal") }}</h5>
          </div>
        </div>

        <div :class="{ 'col-12': equipmentType === 'iphone' }" class="col-9">
          <div class="row">
            <div
              v-for="(
                promotionDeal, promotionIndex
              ) in commonUtils.sortByParams(promotionDeals, 'sequenceNumber')"
              :key="promotionIndex"
              class="col-4 mg-t-10"
            >
              <div class="imagination_boxed">
                <a
                  v-if="promotionDeal && promotionDeal.image"
                  :href="
                    promotionDeal.links === null ? '#' : promotionDeal.links
                  "
                >
                  <img :src="baseUrl + promotionDeal.image.url" alt="img" />
                </a>
                <h3>
                  <a
                    :href="
                      promotionDeal.links === null ? '#' : promotionDeal.links
                    "
                    >{{ promotionDeal.title }}</a
                  >
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
